import * as Styles from './FilterTabs.styles';

const DEFAULT_ACCENT = '#054AD9';

export type FilterTab = {
  /** Unique key used as the tab value. */
  key: string;
  /** Display label for the tab. */
  label: string;
  /** Optional count badge appended to the label (e.g. "To Do (5)"). */
  count?: number;
};

export type FilterTabsProps = {
  /** Array of tab definitions. */
  tabs: FilterTab[];
  /** The key of the currently active tab. */
  activeKey: string;
  /** Callback fired when the active tab changes. */
  onChange: (key: string) => void;
  /** Color for the active tab indicator and text. Defaults to the brand primary. */
  color?: string;
};

const FilterTabs = function ({
  tabs,
  activeKey,
  onChange,
  color = DEFAULT_ACCENT,
}: FilterTabsProps): JSX.Element {
  return (
    <Styles.Wrapper>
      {tabs.map((tab) => (
        <Styles.Tab
          key={tab.key}
          $active={tab.key === activeKey}
          $accentColor={color}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
          {tab.count != null && <Styles.Count>({tab.count})</Styles.Count>}
        </Styles.Tab>
      ))}
    </Styles.Wrapper>
  );
};

export default FilterTabs;
